angular.module("vgresiduos").controller("DisposalCollectionRequestReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios/destinacoes-com-solicitacoes");
		};
	}
]);
